import { formatCurrency } from '@/services/convert'
import { showNotification } from '@/services/calculate'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { updateMultipleGridRecord, updateRowStyle } from '@/services/grid'
import { AgGridVue } from 'ag-grid-vue'
import _ from 'lodash'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import EstimateGrid from '@/components/DynamicComponents/Projects/NewConstruction/EstimateGroups/Grid'
import EstimateInfo from '@/components/DynamicComponents/Projects/EstimateInfo'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'estimate-grid': EstimateGrid,
    'estimate-info': EstimateInfo,
  },
  props: [
    'costDetails',
    'takeoffs',
    'columns',
    'groupDetails',
    'dropdownData',
    'screenIndentifier',
    'activeTab',
    'isArchive',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: false,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          menuTabs: ['filterMenuTab'],
          editable: false,
          sortable: true,
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '16rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      pinnedTopRowData: [],
      groups: [],
      visible: false,
      residual: 0,
      variance: 0,
      colorCode: '#71283e',
      domLayout: null,
      url: undefined,
      visibleEstimateInfo: false,
      isValidTakeoff: false,
      checked: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.domLayout = 'autoHeight'
    this.visible = this.groupDetails.estimateMethod === 2
    if (this.visible) {
      this.calculatePercentage(this.takeoffs, this.costDetails)
    } else {
      this.calculateVariance(this.takeoffs, this.costDetails)
    }
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    takeoffs() {
      this.getData(this.gridOptions)
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        customFilter: CustomFilter,
        costPriceCellRenderer: CurrencyRenderer,
        toolTipRenderer: ToolTipRenderer,
      }

      this.columnDefs = [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          filter: false,
          width: 5,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          headerClass: 'header-left',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => updateRowStyle(params, 'costType', 'left'),
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => updateRowStyle(params, 'contract', 'left'),
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => updateRowStyle(params, 'categoryCode', 'left'),
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => updateRowStyle(params, 'takeoff', 'left'),
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          headerClass: 'header-right',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellStyle: params => updateRowStyle(params, 'unitCost', 'right'),
        },
        {
          headerName: 'Trended Cost',
          field: 'trendedCost',
          headerTooltip: 'Trended Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          headerClass: 'header-right',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellStyle: params => updateRowStyle(params, 'trendedCost', 'right'),
        },
        {
          headerName: 'ID',
          field: 'id',
          headerTooltip: 'ID',
          width: 60,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-left',
          cellStyle: params => updateRowStyle(params, 'id', 'left'),
        },
        {
          headerName: 'Tile Name',
          field: 'tileName',
          headerTooltip: 'Tile Name',
          width: 150,
          wrapText: false,
          cellRendererParams: {
            searchType: 'string',
          },
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => updateRowStyle(params, 'tileName', 'left'),
        },
      ]
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    getData(params) {
      this.visible = this.groupDetails.estimateMethod === 2
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.costDetails)
      this.isValidTakeoff = this.costDetails.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 241 + 'px'
      }
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#estimateTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    onChange(value) {
      this.visible = value
      this.residual = 0.0
      const url = projectAPIs.project.asset.estimate.update(
        this.$route.params.id,
        this.groupDetails.assetId,
      )

      const request = [
        {
          id: this.groupDetails.id,
          estimateMethod: value ? 2 : 1,
        },
      ]
      const msg = 'Please wait while update estimate method...'
      this.$root.$emit('popupUpdation', true, true, msg)
      instance
        .patch(url, request)
        .then(response => {
          this.$emit('updateMethod', value ? 2 : 1)
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },

    deleteCostDetails() {
      if (this.selectedRowKeys.length > 0) {
        var that = this
        this.$confirm({
          title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
          content: h => (
            <div style="color:red">
              <p>This action will delete all information related these rows.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(null)
          },
        })
      } else {
        showNotification(
          'warning',
          'Cost Details',
          'Please select at least one line item!',
        )
      }
    },

    confirmDelete() {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.costDetails.delete(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      instance
        .delete(url, { data: this.selectedRowKeys })
        .then(response => {
          this.selectedRowKeys.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          this.gridOptions.api.applyTransaction({
            remove: this.selectedRows,
          })
          if (this.visible) {
            this.calculatePercentage(this.takeoffs, this.data)
          } else {
            this.calculateVariance(this.takeoffs, this.data)
          }
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.selectedRowKeys = []
          this.selectedRows = []
          this.loading = false
          this.$emit('deleteCostDetail')
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          this.loading = false
          errorService(err)
        })
    },

    updateTakeoff(data) {
      let newData = [...this.data]
      newData = _.get(data, 'costDetails', [])
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateMultipleGridRecord(this.gridOptions, newData)
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      if (this.visible) {
        this.calculatePercentage(
          _.get(data, 'takeoffs', []),
          _.get(data, 'costDetails', []),
        )
      } else {
        this.calculateVariance(
          _.get(data, 'takeoffs', []),
          _.get(data, 'costDetails', []),
        )
      }
      let isValid = true
      const takeoffs = [
        ..._.get(data, 'costDetails', []),
        ..._.get(data, 'takeoffs', []),
      ]
      isValid = takeoffs.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      this.$emit('checkValidTab', this.groupDetails.id, !isValid)
    },

    calculatePercentage(takeoffs, lineItems) {
      const takeoffTotal = takeoffs.reduce((total, item) => {
        return total + _.get(item, 'estimatedCost', 0)
      }, 0)
      const lineTotal = lineItems.reduce((total, item) => {
        return total + _.get(item, 'estimatedCost', 0)
      }, 0)

      if (lineItems.length > 0) {
        this.residual = ((takeoffTotal / lineTotal) * 100).toFixed(2)
      } else {
        this.residual = 0.0
      }
    },

    calculateVariance(takeoffs, lineItems) {
      const takeoffTotal = takeoffs.reduce((total, item) => {
        return total + _.get(item, 'totalPrice', 0)
      }, 0)
      const lineTotal = lineItems.reduce((total, item) => {
        return total + _.get(item, 'unitCost', 0)
      }, 0)

      if (lineItems.length > 0) {
        this.variance = (takeoffTotal / lineTotal).toFixed(2)
      } else {
        this.variance = 0.0
      }
    },

    showEstimateInfo() {
      this.url = projectAPIs.project.asset.estimate.takeoff.info(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      this.visibleEstimateInfo = !this.visibleEstimateInfo
    },

    closeEstimateInfo() {
      this.visibleEstimateInfo = false
    },

    refreshColumns() {
      const displayColumns = this.columnDefs
      displayColumns.map(col => {
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        if (col.field === 'checkbox') {
          col.hide = this.isArchive
        }
      })
      return displayColumns
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
    },
  },
}
